import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getExportTruckLayout } from "../../infrastructure/redux/PlanningThunks";
import { RouteModel } from "../../domain/models/routeModel";

interface TruckLayoutExportButtonProps {
  route: RouteModel;
}

export const TruckLayoutExportButton = ({
  route,
}: TruckLayoutExportButtonProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const handleClick = async function () {
    const response = await dispatch(
      getExportTruckLayout({ id: route.id }),
    ).unwrap();

    if (response?.url) {
      const link = document.createElement("a");
      link.href = response.url;
      link.download = response.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Button
      variant={"primary"}
      className="btn-sm"
      onClick={handleClick} // eslint-disable-line @typescript-eslint/no-misused-promises
    >
      {t("Download truck layout")}
    </Button>
  );
};
